import { render, staticRenderFns } from "./DomainOppositionResponsibleList.vue?vue&type=template&id=6e6a2f68&"
import script from "./DomainOppositionResponsibleList.vue?vue&type=script&lang=js&"
export * from "./DomainOppositionResponsibleList.vue?vue&type=script&lang=js&"
import style0 from "./DomainOppositionResponsibleList.vue?vue&type=style&index=0&id=6e6a2f68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports